/**
 * ViewJobsPage — standalone page for /viewJobs routes.
 * Mirrors Flutter routing where /viewJobs navigates to WebProfile
 * with profileTabIndex=1.
 *
 * This page renders the Profile layout with the View Jobs tab active.
 */
import { PageLayout } from '@/components/layout/PageLayout';
import { ViewJobsSection } from '@/features/profile/components/ViewJobsSection';
import { HiredRequisitionsProvider } from '@/features/onboarding/entry';

export function ViewJobsPage() {
  return (
    <PageLayout>
      {/* Candidate onboarding (React only, FLUTTER_DEVIATIONS §5): the jobs the candidate is hired for, loaded once
          for the Onboarding buttons on the cards and the detail panel; nothing in prod */}
      <HiredRequisitionsProvider>
        <ViewJobsSection />
      </HiredRequisitionsProvider>
    </PageLayout>
  );
}
